// Taken from: https://colorhunt.co/palette/171695

const grey = "#f1f3f4";
const darkGreen = "#496464";
const darkgrey = "#dcdcdc";
const green = "#c6dce6";
const orange = "#ffa41b"
const blue = "#535978";
const darkBlue = "#3A405F";
const darkerBlue = "#202645";
const pink = "#f1d4ce";
const darkPink = "#b38e86";
const pinkHighlight = "#ff7b76";



export default {
  grey,
  green,
  orange,
  darkGreen,
  darkgrey,
  blue,
  darkBlue,
  darkerBlue,
  pink,
  darkPink,
  pinkHighlight,
};
